import React, { useContext } from 'react'
import './Body.scss'
import { SPContext } from '../../SPContext'
import EventCarousel from '../carousel/EventCarousel'
import Filter from '../filter/Filter'
import PageLoading from '../helpers/PageLoading'

// const getAllEventQuery = gql``

function Body() {
  const { authStatus, appStatus, isLoggedIn } = useContext(SPContext)
  // console.log({ appStatus })
  return (
    <section className='sp-body'>
      {((authStatus === 'waiting_for_auth_check' ||
        (isLoggedIn && appStatus !== 'ready')) && <PageLoading />) ||
        null}
      {(appStatus === 'ready' && (
        <React.Fragment>
          <EventCarousel max_events={9} />
          <Filter />
        </React.Fragment>
      )) ||
        null}
    </section>
  )
}

export default Body
